import { createAsyncThunk } from "@reduxjs/toolkit";
import { ResourceType } from "@/services/cloudchipr.api";
import { setLiveUsageResourceDetailsDrawerResourceDataThunk } from "@/store/live-usage-mgmt/thunks/resources/setLiveUsageResourceDetailsDrawerResourceDataThunk";
import { resourceTypesMappingForAttachments } from "@/store/live-usage-mgmt/thunks/utils/constants";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { initiateResourceDetailsDrawerThunk } from "@/store/resource-details/thunks/initiateResourceDetailsDrawerThunk";
import { getProviderTypeByResourceType } from "@/utils/helpers/providers/getProviderTypeByResourceType";
import { getResourceDetailsSingleResourceDataThunk } from "@/store/resource-details/thunks/data/getResourceDetailsSingleResourceDataThunk";

interface FindAndSetAttachResourceDetailsDrawerThunkArgs {
  providerUniqueId: string;
  accountId: string;
  resourceType: ResourceType;
}
export const findAndSetAttachResourceDetailsDrawerThunk = createAsyncThunk(
  "liveUsageMgmt/findAndSetAttachResourceDetailsDrawer",
  async (
    {
      providerUniqueId,
      resourceType,
      accountId,
    }: FindAndSetAttachResourceDetailsDrawerThunkArgs,
    { dispatch },
  ) => {
    const attachedResourceTypes =
      resourceTypesMappingForAttachments.get(resourceType);

    if (!attachedResourceTypes) {
      return;
    }

    const provider = getProviderTypeByResourceType(
      attachedResourceTypes.at(0) as ResourceType,
    );

    dispatch(
      initiateResourceDetailsDrawerThunk({
        openedFrom: "liveUsage",
        availableTabs: ["general", "costs", "metrics", "opportunities"],
        resource: {
          provider,
          region: "",
          accountId: "",
          resourceType: "ebs",
          providerAccountId: "",
          providerAccountName: "",
          name: providerUniqueId,
          provider_unique_identifier: providerUniqueId,
          billing_explorer_resource_identifier: [providerUniqueId],
        },
      }),
    );

    const resourceData = await dispatch(
      getResourceDetailsSingleResourceDataThunk({
        provider,
        accountId,
        resourceId: providerUniqueId,
      }),
    ).unwrap();

    if (resourceData) {
      dispatch(
        setLiveUsageResourceDetailsDrawerResourceDataThunk(
          resourceData as AllTypeResourceItem,
        ),
      );
    }
  },
);
